module.exports = __webpack_public_path__ + "static/img/head1.fc2d7f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/head1.png
// module id = iRhH
// module chunks = 1